import * as React from 'react';
import './Button.css';
import cn from 'classnames';

interface Props {
	className?: string;
	onClick?: () => void;
	ref?: any;
	type?: 'primary' | 'secondary';
	isLoading?: boolean;
}

const Button: React.FunctionComponent<Props> = props => {
	return <div
		className={cn(`button ${props.className}`, {
			'button_primary': props.type === 'primary',
			'button_loading': props.isLoading
		})}
		onClick={!props.isLoading ? props.onClick : () => {}}
		ref={props.ref}
	>
		{props.isLoading ? '...' : props.children}
	</div>;
};

export default Button;
